import Vue from "vue";
import Router from "vue-router";
import UserPersonalData from "./views/UserPersonalData";
import Areas from "./views/Areas";
import Contributions from "./views/Contributions";
import ExtraProtection from "./views/ExtraProtection";
import Scenario from "./views/Scenario";
import Login from "./views/Login";
import SaveSimulationForm from "./views/Summary";
import {
  checkAreaDataIsInvalid,
  checkBaseDataIsInvalid,
  checkScenarioDataIsInvalid
} from "./helpers/store.utils";
import Home from "./views/Home";
import Logout from "./views/Logout";
// import ServiceNotAvailable from "./views/ServiceNotAvailable";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    // {
    //   path: '*',
    //   component: ServiceNotAvailable
    // },
    // {
    //   path: "/service-not-available",
    //   name: "Service Not Available",
    //   component: ServiceNotAvailable
    // },
    {
      path: "/login",
      name: "Login",
      component: Login
    },
    {
      path: "/logout",
      name: "Logout",
      component: Logout
    },
    {
      path: "/",
      name: "Home",
      component: Home,
      beforeEnter: (to, from, next) => {
        // check auth
        next();
      }
    },
    {
      path: "/user-data",
      name: "UserData",
      component: UserPersonalData,
      beforeEnter: (to, from, next) => {
        // check auth
        next();
      }
    },
    {
      path: "/areas",
      name: "Areas",
      component: Areas,
      beforeEnter: (to, from, next) => {
        if (checkBaseDataIsInvalid()) {
          next("/");
        }
        next();
      }
    },
    {
      path: "/contributions",
      name: "Contributions",
      component: Contributions,
      beforeEnter: (to, from, next) => {
        if (checkAreaDataIsInvalid()) {
          next("/");
        }
        next();
      }
    },
    {
      path: "/extra-protections",
      name: "Extra Protection",
      component: ExtraProtection,
      beforeEnter: (to, from, next) => {
        if (checkAreaDataIsInvalid()) {
          next("/");
        }
        next();
      }
    },
    {
      path: "/scenario",
      name: "Scenario",
      component: Scenario,
      beforeEnter: (to, from, next) => {
        if (checkScenarioDataIsInvalid()) {
          next("/");
        }
        next();
      }
    },
    {
      path: "/summary",
      name: "Summary",
      component: SaveSimulationForm,
      beforeEnter: (to, from, next) => {
        if (checkScenarioDataIsInvalid()) {
          next("/");
        }
        next();
      }
    }
  ]
});
